import defaultPalette from '../palette';
import defaultTypography from '../theme/typography';
export default (function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.palette, palette = _f === void 0 ? defaultPalette : _f, _g = _a.typography, typography = _g === void 0 ? defaultTypography : _g;
    return {
        MuiTableCell: {
            root: {
                borderBottom: 'none',
            },
            stickyHeader: {
                backgroundColor: palette === null || palette === void 0 ? void 0 : palette.core[200],
                color: (_b = palette === null || palette === void 0 ? void 0 : palette.text) === null || _b === void 0 ? void 0 : _b.primary,
            },
            head: {
                backgroundColor: palette === null || palette === void 0 ? void 0 : palette.core[200],
                color: (_c = palette === null || palette === void 0 ? void 0 : palette.text) === null || _c === void 0 ? void 0 : _c.primary,
                fontSize: (_d = typography === null || typography === void 0 ? void 0 : typography.h5) === null || _d === void 0 ? void 0 : _d.fontSize,
                fontWeight: (_e = typography === null || typography === void 0 ? void 0 : typography.h5) === null || _e === void 0 ? void 0 : _e.fontWeight,
            },
        },
    };
});
